/**
 * @generated SignedSource<<08da4b33ef9e00b6ba29700828cd45fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StreamTab_activity$data = ReadonlyArray<{
  readonly __typename: "MessageActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly bodyHtml: string | null;
  readonly authorType: string;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly direction: string | null;
  readonly " $fragmentType": "StreamTab_activity";
} | {
  readonly __typename: "InternalCommentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly mentionedUsers: ReadonlyArray<{
    readonly id: string;
    readonly fullName: string | null;
  }>;
  readonly " $fragmentType": "StreamTab_activity";
} | {
  readonly __typename: "EventActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly " $fragmentType": "StreamTab_activity";
} | {
  readonly __typename: "AttachmentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly " $fragmentType": "StreamTab_activity";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "StreamTab_activity";
}>;
export type StreamTab_activity$key = ReadonlyArray<{
  readonly " $data"?: StreamTab_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamTab_activity">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "StreamTab_activity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyHtml",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorType",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        }
      ],
      "type": "MessageActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "mentionedUsers",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "InternalCommentActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v5/*: any*/),
      "type": "EventActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v5/*: any*/),
      "type": "AttachmentActivity",
      "abstractKey": null
    }
  ],
  "type": "ActivityEvent",
  "abstractKey": "__isActivityEvent"
};
})();

(node as any).hash = "7066b3afe2f46d80425b55917e548ff6";

export default node;
